import axios from "axios";
import BASE_URL from "../../config";

const getAuthHeader = () => {
  const tokenData = JSON.parse(localStorage.getItem("authUser") || "{}");
  return {
    Authorization: `Bearer ${tokenData.accessToken}`,
    'Content-Type': 'application/json'
  };
};

export const getStockByProduct = async (productId, businessId = null, branchId = null) => {
  try {
    const response = await axios.post(`${BASE_URL}/api/PurchaseOrder/get-stock-by-product`, {
      Product_Id: productId,
      Business_Id: businessId,
      Branch_Id: branchId  // NEW PARAMETER
    }, {
      headers: getAuthHeader(),
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching stock by product:", error);
    throw error;
  }
};
